import styled from 'styled-components';
import { black, gray, quinary, secondary, tertiary, white } from '~/components/mixins/color';

export const Row = styled.div`
  display: grid; 
  grid-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
`;

export const RowAction = styled.div`
  display: grid; 
  grid-gap: 10px;
  grid-template-columns: 1fr 48px;

  button {
    height: 48px;
    margin: 0;
    width: 46px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 100%;

  .contents {
    display: grid;
    grid-template-columns: 400px 1fr;
    grid-gap: 10px;
    width: 100%;
    height: calc(100% - 60px);
  }
  .form-data {
    background: ${white.hex()};
    padding: 10px;
    padding-bottom: 0px;
    margin-bottom: 10px;
  }
  .toolbar {
    display: flex;
    min-height: 56px;
    height: 56px;
    padding: 0 10px;
    margin-top: 10px;
    background: ${white.hex()};
    align-items: center;
    justify-content: flex-end;
  }
`;

export const DetailContainer = styled.ul`
  display: grid;
  grid-auto-columns: minmax(204px, 1fr);
  grid-auto-flow: row;
  grid-row-gap: 10px;
  align-content: flex-start;
  padding: 10px;
  background: ${white.hex()};

  width: 100%;
  height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  > :last-child {
    margin-bottom: 10px;
  }
`;

export const Card = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: ${secondary.hex()};
  align-items: center;
  border-left: 5px solid ${(props) => props.color || white.hex()};
  height: 46px;
  border-radius: 3px 0px 0px 3px;
  padding: 10px;
  box-shadow: 1px 1px 1px ${tertiary.hex()};
  min-width: 260px;
  color: ${gray.hex()};

  .title {
    font-size: 15px;
  }

  .value {
    padding: 10px;
    font-size: 14px;
  }
`;

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  div.row {
    display: grid;
    grid-template-columns: 40px 1fr;

    @media (max-width: 960px) {
      grid-row-gap: 10px;
    }

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${white.alpha(0.8).toString()};
      border-radius: 8px 0px 0px 8px;
      color: ${white.hex()};
      font-size: 14px;
      font-weight: bold;
      margin: 0px 0px 2px 0px;
      text-align: center;
      padding: 10px;
    }

    .columns {
      display: grid;
      grid-template-columns: repeat(auto-fill, min(260px, 1fr));
      grid-auto-columns: minmax(260px, 1fr);
      grid-auto-flow: column;
      grid-gap: 0px;
      align-items: center;
      background: ${white.alpha(0.05).toString()};
      margin-bottom: 2px;

      @media (max-width: 960px) {
        grid-auto-flow: row;
        grid-auto-columns: minmax(180px, 1fr);
      }

      .column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 0px;
        padding: 10px;

        &:hover {
          background: ${black.alpha(0.02).toString()};
          cursor: pointer;
          border-radius: 2px;
        }

        label {
          margin: 0px 10px 5px 10px;
          font-size: 14px;
          color: #555;
        }

        .value {
          display: flex;
          justify-content: center;
          font-size: 16px;
          margin-left: 10px;
          color: #555;
        }
      }
    }
  }
`;

export const FormToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  height: 56px;
  border-top: 1px solid ${quinary.hex()};

  .buttons {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  min-height: 44px;
  min-height: 44px;
  padding: 0 15px;
  color:  ${gray.hex()};
  background: ${white.hex()};
  border-bottom: 1px solid ${secondary.hex()};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${secondary.hex()};

  .list {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: calc(100vh - 250px);
  }
  .form {
    display: flex;
    flex: 0 0 80px;
    flex-direction: row;
    background-color: ${white.hex()};
    width: 100%;
    padding: 10px 10px 0 10px;
  }
`;

export const ExpandContainer = styled.div`
  width: 100%;
  height: calc(100vh - 419px);
  border: 2px solid ${secondary.hex()};
  border-top: none;
  min-height: 120px;
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 10px;
  background: ${secondary.hex()};

  h4 {
    color: ${gray.hex()};
    font-weight: normal;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  img {
    max-width: 180px;
  }
`;